import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import actions from './actions';
import state from './state';
import getters from './getters';
import mutations from './mutations';

export const serviceComputed = {
	...mapGetters('mesEqipNoPopupStore', Object.keys(getters)),
	...mapState('mesEqipNoPopupStore', Object.keys(state))
};
export const serviceMethods = {
	...mapActions('mesEqipNoPopupStore', Object.keys(actions)),
	...mapMutations('mesEqipNoPopupStore', Object.keys(mutations))
};
